/*@ngInject*/
const UILoaderDirective = function () {

    let linkFunction = function ($scope, $elm, $attrs) {
        $scope.type = 'light';

        if ($attrs.type === 'dark') {
            $scope.type = 'dark';
        }
    };

    return {
        restrict: 'E',
        replace: true,
        link: linkFunction,
        templateUrl: '/ui/uiLoader.tpl.html'
    };
};

angular.module('umCore')
    .directive('uiLoader', UILoaderDirective);
